import AdminTab from "./Admin"
import { useNavigate, useParams } from "react-router-dom"
import permissions, { isAuthorized } from "client/utils/Permissions";

const AdminTabContainer = () => {
    let { page } = useParams();
    const navigate = useNavigate();

    const acquisitionListingLinkClick = (e: any, link: any) => {
        e.preventDefault()
        if (link == "Disposition Penalty Flag") {
            if (page === 'dashboard') {
                window.open('/ordermanagement/dispositionpenaltyflag', '_blank', 'noopener,noreferrer');
            } else {
                navigate('/ordermanagement/dispositionpenaltyflag')
            }
        } else if (link == "Acquisition Code Maintenance") {
            if (page === 'dashboard') {
                window.open('/ordermanagement/acquisitioncodemaintenance', '_blank', 'noopener,noreferrer');
            }
            else {
                navigate('/ordermanagement/acquisitioncodemaintenance')
            }

        } else if (link == "Asset Audit Reset History") {
            if (page == 'dashboard') {
                window.open('/ordermanagement/assetauditresethistory', '_blank', 'noopener,noreferrer');
            }
            else {
                navigate('/ordermanagement/assetauditresethistory')
            }
        } else if (link == "App OnBoarding") {
            window.open('/Administration/apponboarding', '_blank', 'noopener,noreferrer');
        }
        else if (link == "Application Permissions") {
            window.open('/Administration/applicationpermission', '_blank', 'noopener,noreferrer');
        }
        else if (link == "Roles") {
            window.open('/Administration/roles', '_blank', 'noopener,noreferrer');
        }
        else if (link == "User Management") {
            window.open('/Administration/usermanagement', '_blank', 'noopener,noreferrer');
        }
        else {
            if (page === 'dashboard') {
                window.open('/ordermanagement/outofofficeoverride', '_blank', 'noopener,noreferrer');
            } else {
                navigate('/ordermanagement/outofofficeoverride')
            }
        }
    }

    const adminListing: any = [];

    if (isAuthorized(permissions.Create_Edit_Admin) || page === 'dashboard' || isAuthorized(permissions.ViewAdmin)) {
        adminListing?.push({
            id: 1,
            type: 'DISPOSITION SETTINGS',
            typeListing: [
                {
                    id: 1,
                    link: 'Disposition Penalty Flag',
                    isAllowed: (isAuthorized(permissions.ViewAdmin) || page === 'dashboard')
                },
                {
                    id: 2,
                    link: 'Acquisition Code Maintenance',
                    isAllowed: (isAuthorized(permissions.ViewAdmin) || page === 'dashboard')
                }
            ]
        });

        adminListing?.push({
            id: 3,
            type: 'Asset Audit Reset History',
            typeListing: [
                {
                    id: 1,
                    link: 'Asset Audit Reset History',
                    isAllowed: (isAuthorized(permissions.ViewAdmin) || page === 'dashboard')
                }
            ]
        });
    }

    if (isAuthorized(permissions.ViewOOFSettings) || page === 'dashboard') {
        const approvalSettings = {
            id: 2,
            type: 'APPROVAL SETTINGS',
            typeListing: [
                {
                    id: 1,
                    link: 'Out of Office Override',
                    isAllowed: (isAuthorized(permissions.ViewAdmin) || page === 'dashboard')
                }
            ]
        };

        if (adminListing?.length === 0) {
            adminListing?.push(approvalSettings);
        } else {
            adminListing?.splice(1, 0, approvalSettings);
        }
    }

    if(page === 'dashboard'){
        const dashBoardSettings = {
            id: 2,
            type: 'SITE ADMINISTRATION',
            typeListing: [
                // {
                //     id: 1,
                //     link: 'App OnBoarding',
                //     isAllowed: true
                // },
                // {
                //     id: 1,
                //     link: 'Application Permissions',
                //     isAllowed: true
                // },
                {
                    id: 1,
                    link: 'Roles',
                    isAllowed: true
                },
                {
                    id: 1,
                    link: 'User Management',
                    isAllowed: true
                }
            ]
        };
        adminListing.push(dashBoardSettings);
    }


    return (
        <AdminTab
            acquisitionListingLinkClick={acquisitionListingLinkClick}
            adminListing={adminListing}
        />
    )
}

export default AdminTabContainer